import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeesVsAttendanceDTO } from "./employees-vs-attendance-dto";


export class ProjectWiseEmployeeAttendance extends GlobalResponseObject {
    data?: EmployeesVsAttendanceDTO[];
}

